import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { AcademyProvider } from './context/AcademyContext'
import { AuthProvider } from './context/AuthContext'
import { AppLayout, PublicLayout } from './components/Layout'
import { AdminRoute, ProtectedRoute } from './components/RouteGuards'
import { AdminPage } from './pages/AdminPage'
import { AuthPage, SetupAdminPage, UpdatePasswordPage } from './pages/AuthPage'
import { CommunityPage } from './pages/CommunityPage'
import { CertificatePage, DashboardPage, LearningCoursePage, QuizPage } from './pages/LearningPages'
import { LibraryPage } from './pages/LibraryPage'
import { ProfilePage } from './pages/ProfilePage'
import { CatalogPage, CommunityRulesPage, CourseDetailPage, LandingPage, PaymentResultPage, PrivacyPage } from './pages/PublicPages'

function PublicRoute() {
  return <PublicLayout><Outlet /></PublicLayout>
}

function PrivateRoute() {
  return <AppLayout><Outlet /></AppLayout>
}

export default function App() {
  return <BrowserRouter><AuthProvider><AcademyProvider><Routes>
    <Route element={<PublicRoute />}>
      <Route index element={<LandingPage />} />
      <Route path="cursos" element={<CatalogPage />} />
      <Route path="cursos/:slug" element={<CourseDetailPage />} />
      <Route path="comunidad/normas" element={<CommunityRulesPage />} />
      <Route path="privacidad" element={<PrivacyPage />} />
      <Route path="pago/:status" element={<PaymentResultPage />} />
    </Route>
    <Route path="ingresar" element={<AuthPage />} />
    <Route path="actualizar-clave" element={<UpdatePasswordPage />} />
    <Route path="configurar-administradora" element={<SetupAdminPage />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<PrivateRoute />}>
        <Route path="mi-aprendizaje" element={<DashboardPage />} />
        <Route path="aprender/:courseId/:lessonId?" element={<LearningCoursePage />} />
        <Route path="cuestionario/:courseId" element={<QuizPage />} />
        <Route path="certificado/:courseId" element={<CertificatePage />} />
        <Route path="comunidad" element={<CommunityPage />} />
        <Route path="biblioteca" element={<LibraryPage />} />
        <Route path="perfil" element={<ProfilePage />} />
        <Route element={<AdminRoute />}><Route path="administracion" element={<AdminPage />} /></Route>
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></AcademyProvider></AuthProvider></BrowserRouter>
}
